import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { BarChart3, LayoutDashboard, LogOut, PhoneOutgoing, Settings, Users } from "lucide-react";
import { useAuth } from "@/admin/AuthContext";

const NAV = [
  ["/admin", "Dashboard", LayoutDashboard, ["SUPER_ADMIN", "ADMIN", "AGENT"]],
  ["/admin/leads", "Leads", Users, ["SUPER_ADMIN", "ADMIN", "AGENT"]],
  ["/admin/callbacks", "Callbacks", PhoneOutgoing, ["SUPER_ADMIN", "ADMIN", "AGENT"]],
  ["/admin/analytics", "Analytics", BarChart3, ["SUPER_ADMIN", "ADMIN"]],
  ["/admin/settings", "Settings", Settings, ["SUPER_ADMIN"]],
];

export const RequireAuth = ({ roles }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="grid min-h-screen place-items-center bg-forest text-sand">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/admin" replace />;
  return <AdminShell />;
};

const AdminShell = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-sand" data-testid="admin-shell">
      <header className="border-b border-border bg-forest px-5 py-3 text-sand lg:px-8">
        <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-4">
          <Link to="/admin" className="flex items-center gap-2 font-display text-base font-bold">
            <img src="/logo-mark.png" alt="" aria-hidden="true" className="h-7 w-7 object-contain" />
            FDA CRM
          </Link>
          <nav className="flex flex-wrap items-center gap-1">
            {NAV.filter(([, , , roles]) => roles.includes(user.role)).map(([to, label, Icon]) => (
              <NavLink key={to} to={to} end={to === "/admin"} data-testid={`admin-nav-${label.toLowerCase()}`}
                className={({ isActive }) => `inline-flex items-center gap-2 rounded-full px-3 py-2 text-xs font-bold uppercase tracking-wider transition-colors ${isActive ? "bg-sand text-forest" : "text-sand/70 hover:text-sand"}`}>
                <Icon className="h-3.5 w-3.5" /> {label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-4">
            <span className="text-xs text-sand/70" data-testid="admin-current-user">{user.name} · {user.role}</span>
            <button onClick={logout} data-testid="admin-logout"
              className="inline-flex items-center gap-2 rounded-full border border-sand/30 px-3 py-1.5 text-xs font-bold uppercase tracking-wider">
              <LogOut className="h-3.5 w-3.5" /> Log out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1600px] px-5 py-8 lg:px-8"><Outlet /></main>
    </div>
  );
};
